import main from "./main.json"

export { main }
